"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var r = require('styled-components');
var reactToggleGroup = require('@radix-ui/react-toggle-group');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var r__default = /*#__PURE__*/_interopDefaultLegacy(r);

var o=r__default["default"].div`
  background: var(--background-toggle-button-label);
  color: var(--foreground-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  font-weight: var(--font-weight-semibold);
  width: 100%;
`,p=r__default["default"].div`
  ${chunkLXX3SSRV_js.b}, img {
    width: 56px;
    height: 56px;
    color: var(--foreground-button-secondary-default);
  }
`,i=r__default["default"](reactToggleGroup.Item)`
  box-sizing: content-box;
  background: var(--background-level-1);
  border-radius: var(--border-radius-small);
  border: 1px solid var(--border-input-default);
  cursor: pointer;
  padding: 18px 0px 0px 0px;
  height: 120px;
  max-width: 260px;
  min-width: 140px;
  overflow: hidden;
  flex: 1 0 calc((100% / 4) - 10px);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;

  > ${o} {
    padding-bottom: 6px;
  }

  &[data-state='on'] {
    padding-top: 17px;
    border: 2px solid var(--border-input-active);
    > ${o} {
      padding-bottom: 5px;
    }
  }

  :hover {
    border-width: 2px;
    border-color: var(--border-input-hover);
    background: var(--background-selected);
    padding-top: 17px;
    > ${o} {
      color: var(--foreground-primary);
      padding-bottom: 5px;
    }
  }
`,n=r__default["default"](reactToggleGroup.Root)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--spacing-regular);
`;var a=({children:s,label:t,...u})=>jsxRuntime.jsxs(i,{...u,children:[jsxRuntime.jsx(p,{children:s}),t&&jsxRuntime.jsx(o,{children:t})]});a.displayName="TileButton";var f=r__default["default"](a)``;var d=n;d.displayName="TileGroupProps";var T=r__default["default"](d)``;

exports.a = f;
exports.b = T;
